import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import "./AboutMegaMenu.css";

const aboutItems = [
  {
    title: "Who we are",
    subtitle: "Learn more about us",
    to: "/about",
    featured: true,
  },
  {
    title: "Careers",
    subtitle: "See our job opportunities",
    to: "/careers",
  },
  {
    title: "Blog",
    subtitle: "News and articles",
    to: "/blog",
  },
  {
    title: "Downloads",
    subtitle: "Download our documents",
    to: "/downloads",
  },
  {
    title: "Academy",
    subtitle: "Get professional training",
    to: "/academy",
  },
  {
    title: "Contact us",
    subtitle: "Get in touch with us",
    to: "/contactus",
  },
];

const AboutMegaMenu = () => {
  return (
    <div className="aboutMegaMenu">
      <div className="aboutMegaMenu-header">
        <h3>ABOUT US</h3>
        <p>Learn more about IRQGYP and find related links</p>
      </div>

      <div className="aboutMegaMenu-grid">
        {aboutItems.map((item) => (
          <Link
            to={item.to}
            className="aboutMegaMenu-card"
            key={item.title}
          >
            <div className="aboutMegaMenu-cardTop">
              <h4>{item.title}</h4>
              <FiArrowUpRight />
            </div>
            <p>{item.subtitle}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AboutMegaMenu;
